module.exports = "<message autoHide=\"true\" autoHideTime=\"5000\"></message>\n<form name=\"integrationForm\" class=\"mss-form\" novalidate>\n    <integration-settings original-data=\"vm.placement.data\"\n                          original-parent-data=\"vm.placement.parentData\"\n                          integration-form=\"integrationForm\"\n                          location=\"vm.placement.location\"\n                          outlets-summary-data=\"vm.placement.outletsSummaryData\">\n    </integration-settings>\n</form>";


//////////////////
// WEBPACK FOOTER
// ./src/integration-settings/controllers/index.html
// module id = 283
// module chunks = 0